// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.entrypoint.headerComponent.';

const BACK = `${DOMAIN}backLink`;

export { BACK };
